import { ExcelTemplate } from "../../interfaces";
import * as XLSX from 'xlsx-js-style';
import { setColumnWidth, withHeaderStyling } from "../../utils";
import { fitToColumn } from "../financial-statement/utils";
import { getPreparedData } from "./mapping";
import { HideableRecoveryUserDTO } from "src/app/domain/recovery/dto/RecoveryUserDTO";


export class UserRecoveryTemplate implements ExcelTemplate {
  export(recoveryUsers: HideableRecoveryUserDTO[]): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(recoveryUsers);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  getSheet(recoveryUsers: HideableRecoveryUserDTO[]): XLSX.WorkSheet {
    const preparedData = getPreparedData(recoveryUsers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    setColumnWidth(sheet, 0, 30);
    return withHeaderStyling(sheet);
  }
}
